"use client";
import { jsx as s } from "react/jsx-runtime";
import * as i from "react";
import { cn as n } from "./index15.js";
const a = i.forwardRef(
  ({ className: e, type: t, ...o }, r) => /* @__PURE__ */ s(
    "input",
    {
      type: t,
      className: n(
        "flex h-9 w-full rounded border border-border bg-surface px-3 py-1 text-sm text-text shadow-sm transition-colors",
        "placeholder:text-text-muted",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent",
        "disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: r,
      ...o
    }
  )
);
a.displayName = "Input";
export {
  a as Input
};
//# sourceMappingURL=index10.js.map
